import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  to?: string;
  linkLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  to,
  linkLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="mb-5 flex items-end justify-between gap-4">
      <div>
        <div className="flex items-center gap-2">
          <span className="h-5 w-1 rounded-full bg-accent-500"></span>
          <h2 className="font-heading text-lg font-bold text-foreground-900 md:text-xl">
            {title}
          </h2>
        </div>
        {subtitle && (
          <p className="mt-1.5 pl-3 text-xs text-foreground-500 md:text-sm">{subtitle}</p>
        )}
      </div>
      {to && (
        <Link
          to={to}
          className="flex shrink-0 items-center gap-1 whitespace-nowrap text-sm text-secondary-600 transition-colors hover:text-secondary-700"
        >
          {linkLabel}
          <i className="ri-arrow-right-s-line text-base"></i>
        </Link>
      )}
    </div>
  );
}